@use '@/scss/underscore' as _;

.darkModeTip {
  display: flex;
  align-items: baseline;
  font: var(--font-body-2);
  color: var(--color-text-secondary);
  margin-top: _.unit(1);
}
